import { Box, Button as MUIButton } from "@mui/material";
import Addicon from "@mui/icons-material/Add";
import UserLineIcon from "remixicon-react/UserLineIcon";

import { useState } from "react";
import { Alert, Button, InfoContainer, Modal, Popin, Text } from "$components";
import useJStyles from "$hooks/useJStyles";
import Notes from "$components/Notes";
import QuantityPicker from "$components/QuantityPicker/QuantityPicker";
import { theme } from "$utils/theme/bataillog";
import Block from "../Block";
import sections from "../sections";
import JBadgeList from "./JBadgeList";
import Divider from "../Divider";
import ButtonList from "./ButtonList";
import Tables from "./Tables";
import BataillogDatePicker from "$components/BataillogDatePicker/BataillogDatePicker";

const componentsSection = sections.find((s) => s.id === "components");
const loremIpsum = `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin ultricies lobortis pretium. Praesent imperdiet dui vel risus viverra, et tristique erat egestas. Nunc varius massa non aliquam cursus. Mauris pulvinar sem id justo efficitur feugiat. Morbi sit amet convallis nunc. Nullam malesuada eros sapien, eu consequat exegestas a.`;

const minValue = 5;
const maxValue = 20;

function Components() {
  const { jclasses } = useJStyles();
  const [date, setDate] = useState<Date | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalLoading, setIsModalLoading] = useState(false);
  const [isPopinOpen, setIsPopinOpen] = useState(false);
  const [quantity, setQuantity] = useState(10);

  const handleOnConfirmModal = () => {
    setIsModalLoading(true);
    setTimeout(() => {
      setIsModalLoading(false);
      setIsModalOpen(false);
    }, 1000);
  };

  return (
    <Block id={componentsSection.id} title={componentsSection.label}>
      <ButtonList />

      <Divider />

      <Box
        display="flex"
        style={{ gap: theme.spacing(3) }}
        justifyContent="space-between"
      >
        <Box flex={1}>
          <Text type="h3">Notes repliables</Text>
          <Notes text={loremIpsum} />
        </Box>
        <Box flex={1}>
          <Text type="h3">DatePicker</Text>
          <BataillogDatePicker
            selectedDate={date}
            onDateChange={(dates) => {
              if (!Array.isArray(dates)) {
                setDate(dates);
              }
            }}
            label="Date picker"
          />
        </Box>
        <Box flex={1}>
          <Text type="h3">Quantity picker</Text>
          <Box width="200px">
            <QuantityPicker
              quantity={quantity}
              onQuantityChange={setQuantity}
              maxValue={maxValue}
              minValue={minValue}
            />
            <Text>
              Min = {minValue} | Max = {maxValue}
            </Text>
          </Box>
        </Box>
        <Box flex={1}>
          <Text type="h3">JBadges</Text>
          <JBadgeList />
        </Box>
        <Box flex={1}>
          <Text type="h3">Alerts</Text>
          <Box display="flex" flexDirection="column" style={{ gap: 6 }}>
            <Alert severity="success">Success</Alert>
            <Alert severity="info">Info</Alert>
            <Alert severity="warning">Warning</Alert>
            <Alert severity="error">Error</Alert>
          </Box>
        </Box>
      </Box>

      <Divider />

      <Text type="h3">Info container</Text>
      <Text>
        <i>{`Le composant est utilisé "tel quel" pour montrer son comportement par
        défaut. Cependant, dans l'application, il est bien souvent surchargé...`}</i>
      </Text>
      <InfoContainer
        isToggleable
        leftHeader={
          <>
            <UserLineIcon />
            <Text type="h3">Texte à gauche</Text>
          </>
        }
        rightHeader={
          <MUIButton>
            <Addicon />
            <Text>Action à droite</Text>
          </MUIButton>
        }
      >
        <Text>{loremIpsum}</Text>
        <br />
        <br />
        <Text>{loremIpsum}</Text>
      </InfoContainer>

      <Divider />

      <Box display="flex" style={{ gap: theme.spacing(3) }}>
        <Box width="fit-content">
          <Text type="h3">Modale</Text>
          <span>
            <Button onClick={() => setIsModalOpen(true)}>
              Ouvrir la modale
            </Button>
          </span>
          <Modal
            isLoading={isModalLoading}
            onCancel={() => setIsModalOpen(false)}
            open={isModalOpen}
            onConfirm={handleOnConfirmModal}
            title="Titre de la modale"
          >
            <div className={jclasses.jDialogContent}>
              <Text>
                Les textes des boutons ci-dessous sont ceux par défaut.
              </Text>
            </div>
          </Modal>
        </Box>
        <Box width="fit-content">
          <Text type="h3">Popin</Text>
          <span>
            <Button onClick={() => setIsPopinOpen(true)}>
              Ouvrir la popin
            </Button>
          </span>
          <Popin openPopin={isPopinOpen} toggleDrawer={setIsPopinOpen}>
            <Text type="h2">Un titre pour la popin</Text>
            <Text>{loremIpsum.slice(0, 80)}</Text>
            <br />
            <Text>{loremIpsum.slice(0, 50)}</Text>
            <br />
            <Text>{loremIpsum.slice(0, 70)}</Text>
          </Popin>
        </Box>
      </Box>

      <Divider />

      <Tables />
    </Block>
  );
}

export default Components;
